<template>
    <el-dialog append-to-body :title="form.id ? '修改收货地址' : '新增收货地址'" :visible.sync="localVisible" width="600px"
        @close="handleClose">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="left">
            <el-form-item label="省市区" prop="areaCode">
                <el-cascader v-model="form.areaCode" ref="address" :props="props" :options="regionOptions"
                    @change="regionChange" placeholder="请选择省市区" />
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input v-model="form.address" placeholder="例如：XX路XX号XX室" />
            </el-form-item>
            <el-form-item label="收货人姓名" prop="userName">
                <el-input v-model="form.userName" placeholder="请输入收货人姓名" />
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入手机号" />
            </el-form-item>
            <el-form-item>
                <el-checkbox v-model="form.defaultFlag" :true-label="'1'" :false-label="'0'">设为默认地址</el-checkbox>
            </el-form-item>
        </el-form>
        <div style="text-align: right;">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="success" @click="handleSave"> {{ form.id ? '修改地址' : '保存地址' }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { getXzqArr } from "@/api/add";
import { createAddress, detailAddress, update } from '@/api/sjzx'
import { removeEmptyChildren } from "@/js/utils/util";


export default {
    props: {
        visible: Boolean,
        // regionOptions: Array // 省市区数据
        editId: String
    },
    data() {
        return {
            localVisible: this.visible,
            props: {
                label: "areaName",
                children: "children",
                value: "id",
                checkStrictly: true,
            },
            form: {
                areaCode: '',
                area: '',
                address: '',
                city: '',
                defaultFlag: '',
                id: '',
                phone: '',
                province: '',
                userName: '',
            },
            rules: {
                areaCode: [{ required: true, message: '请选择省市区', trigger: 'change' }],
                address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
                userName: [{ required: true, message: '请输入收货人姓名', trigger: 'blur' }],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ]
            },
            regionOptions: [],//省市区
        };
    },

    watch: {
        visible(val) {
            this.localVisible = val;
            if (this.editId) {
                this.getDetailAddress();
            }
        },
        localVisible(val) {
            this.$emit('update:visible', val);
        }
    },
    mounted() {
        this.getRegions();
    },
    methods: {
        handleClose() {
            // 重置表单内容
            this.form = {
                areaCode: '',
                area: '',
                address: '',
                city: '',
                defaultFlag: '',
                id: '',
                phone: '',
                province: '',
                userName: '',
            };
            // 清除校验
            this.$refs.form && this.$refs.form.resetFields();
            this.localVisible = false; // 关闭弹窗
        },
        async handleSave() {
            //保存或者修改地址
            this.$refs.form.validate(async valid => {
                if (valid) {
                    let params = {
                        ...this.form
                    }
                    let res;
                    if (this.form.id) {
                        // 有id，执行修改
                        res = await update(params);
                    } else {
                        // 无id，执行新增
                        res = await createAddress(params);

                    }
                    if (res.code == 0) {
                        this.$message.success(res.msg)
                    } else {
                        this.$message.error(res.msg)
                    }
                    this.$emit('save', { ...this.form });
                    this.handleClose();
                }
            });
        },
        async getDetailAddress() {
            //回显数据
            console.log('接收到的editId:', this.editId);
            let params = {
                id: this.editId
            }
            let res = await detailAddress(params)
            if (res.code == 0) {
                let { id, address, areaCode, area, userName, phone, defaultFlag } = res.data
                this.form = { id, address, areaCode, area, userName, phone, defaultFlag }
            }
        },
        regionChange() {
            //行政区做切换
            let node = this.$refs.address.getCheckedNodes()[0];
            let { pathLabels, value, } = node
            this.form.areaCode = value
            this.form.province = pathLabels[0]//省
            this.form.city = pathLabels[1]//市
            this.form.area = pathLabels[2]//区    
            setTimeout(() => {
                this.$refs.form.validateField("areaCode");
            }, 100);
        },
        async getRegions() {
            //获取地址树
            let params = {
                level: 3,
            }
            let res = await getXzqArr(params)
            this.regionOptions = removeEmptyChildren(res.data)
            if (this.editId) {
                this.form = {
                    areaCode: '',
                    area: '',
                    address: '',
                    city: '',
                    defaultFlag: '',
                    id: '',
                    phone: '',
                    province: '',
                    userName: '',
                }
            }
        },


    },

};
</script>
